import { GenerationStatus } from '@showbie-socrative/socrative-utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postGenerateActivityInsights } from '../../../../api/activities/insights/postGenerateActivityInsights';
import { queryKey } from '../queryKey';

export function useGenerateInsightsMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postGenerateActivityInsights,
    onMutate: ({ activityInstanceId }) => {
      queryClient.setQueryData(queryKey.insightsById(activityInstanceId), {
        generationStatus: GenerationStatus.Pending,
      });
    },
    onSuccess: (data) => {
      queryClient.setQueryData(
        queryKey.insightsById(data.activityInstanceId),
        data
      );

      return queryClient.invalidateQueries(
        queryKey.insightsById(data.activityInstanceId)
      );
    },
    onError: (error: any, { activityInstanceId }) => {
      /* On error, set the status back to show the generate button
       Check if it's an insufficient data error - this needs special handling
       All other errors (including rate limits) reset to null so the button shows again
      */
      if (error.response?.status === 400 && error.response?.data?.code === 'insufficient_data_error') {
        queryClient.setQueryData(queryKey.insightsById(activityInstanceId), {
          generationStatus: GenerationStatus.InsufficientData,
        });
        return queryClient.invalidateQueries(
          queryKey.insightsById(activityInstanceId)
        );
      }
      
      // For all other errors (including rate limits), reset to null
      // The component's handleInsightsError will show appropriate UI (paywall/toast)
      queryClient.setQueryData(queryKey.insightsById(activityInstanceId), null);
      return queryClient.invalidateQueries(
        queryKey.insightsById(activityInstanceId)
      );
    },
  });
}
